module.exports = __webpack_public_path__ + "media/images/common/logo_vertical-675f8432df553ccfb0cb9daa91748900.png";